export const VEHICLE_TYPE_ANIA_PROPS = [
  { label: 'AUTOVETTURE', key: 'A' },
  { label: 'AUTOBUS', key: 'B' },
  { label: 'AUTOCARRI', key: 'C' },
  { label: 'MOTOCICLI', key: 'M' },
  { label: 'MOTOCARRI', key: 'Q' },
  { label: 'RIMORCHI (non previsto dalla convenzione CARD)', key: 'R' },
  { label: 'MACCHINE AGRICOLE (non previsto dalla convenzione CARD)', key: 'S' },
  { label: 'MACCHINE OPERATRICI', key: 'T' },
  { label: 'CICLOMOTORI (solo se identificabili tramite il nuovo sistema di targatura in vigore dal 14/7/2006', key: 'W' }
];

export const VEHICLE_TYPE_MCTC_PROPS = [
  { label: 'Autoveicolo', key: 'A' },
  { label: 'Macchina agricola operatrice', key: 'V' },
  { label: 'Ciclomotore', key: 'C' },
  { label: 'Motoveicolo', key: 'M' },
  { label: 'Macchina agricola operatrice semoventi a un asse', key: 'U' },
  { label: 'Rimorchio', key: 'R' },
  { label: 'Macchina agricola semovente munita di almeno due assi', key: 'S' },
  { label: 'Rimorchio Agricolo', key: 'T' },
  { label: 'Rimorchio agricolo con massa complessiva a pieno carico non superiore a 1,5 tonnellate', key: 'Y' },
  { label: 'Macchina agricola operatrice trainata', key: 'X' },
  { label: 'Macchina operatrice Semovente', key: 'P' },
  { label: 'Macchina operatrice trainata', key: 'N' },
  { label: 'Macchine operatrici non circolanti', key: 'Z' }
];
